<template>
    <SlideWhite>
        <div class="h-full grid grid-cols-3 gap-[25px]">
            <div class="col-span-2 row-span-2 h-full">
                <div
                    class="h-full w-full relative bg-no-repeat bg-cover bg-center bg-gray-200 flex items-end justify-center flex-grow-0"
                    :style="{ backgroundImage: `url(${bilder[0].tv.u})`}"
                >
                    <div class="flex items-end space-x-[25px] mb-[222px] mx-[112px] w-full">
                        <div class="bg-primary-500 w-[280px] h-[280px] flex-shrink-0 flex items-center justify-center">
                            <Logo class="w-[214px]" />
                        </div>
                        <div class="flex flex-col space-y-[25px]">
                            <ProjektHeadlineLabel :projekt="projekt" class="text-[30.666px] px-[45px]" />
                            <div class="h-[280px] bg-white/75 p-[45px] text-primary-500 flex flex-col justify-end">
                                <div class="text-[41.333px] uppercase font-bold leading-tight mb-[5px]">
                                    <div class="max-w-[600px]">
                                        {{ projekt.r_headline }}
                                    </div>
                                </div>
                                <div class="text-[21.333px]" v-show="projekt.objektadresse_freigeben">
                                    {{ projekt.strasse }} {{ projekt.hausnummer }} | {{ projekt.r_geolage_name }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bg-no-repeat bg-cover bg-center bg-gray-200" :style="{ backgroundImage: `url(${bilder[1].tv.u})`}"></div>
            <div class="bg-no-repeat bg-cover bg-center bg-gray-200" :style="{ backgroundImage: `url(${bilder[2].tv.u})`}"></div>
        </div>
    </SlideWhite>
</template>

<script>
import Logo from '../Partials/Logo.vue'
import ProjektHeadlineLabel from '../Partials/ProjektHeadlineLabel.vue'
import SlideWhite from '../Layouts/SlideWhite.vue'

export default {
    props: {
        projekt: null,
        bilder: [],
        activeSlide: {
            type: Boolean,
            default: false
        },
    },

    mounted() {},

    components: {
        ProjektHeadlineLabel,
        Logo,
        SlideWhite,
    }
}
</script>